import React from "react";
import styles from './styles/comingSoon.module.css'
import Navbar from '../component/navbar/Navbar';

const ComingSoon = () => {
    return (
        <>
            <div>
                <Navbar/>
            </div>
            <div className={styles.comingSoonContainer}>
                <img className={styles.comingSoonImg} src={require('../assets/images/coomingsoon.gif')} alt="comingSon" />
            </div>
        </>
    );
}
export default ComingSoon;